import axios from "./axiosConfig";

const cockroachGameService = {
  getLeaderboard() {
    return axios.get("/game/cockroach/leaderboard");
  },
  submitScore(score) {
    return axios.post("/game/cockroach/score", { score });
  },
};

export default cockroachGameService;
